export const fieldStyles = {
  control: (provided, state) => ({
    ...provided,
    borderColor: "#C7C6C6",
    minHeight: "50px",
    boxShadow: null,
    borderRadius: "10px",
    "&:hover": {
      borderColor: "#C4C4C4",
    },
  }),

  valueContainer: (provided) => ({
    ...provided,
  }),

  multiValue: (styles, { data }) => {
    return {
      ...styles,
      backgroundColor: "#D9D9D9",
      borderRadius: "6px",
      marginRight: "1px",
    };
  },
  multiValueLabel: (styles, { data }) => ({
    ...styles,
  }),

  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      color: "black",
      backgroundColor: "white",
    };
  },
};
